<div style="overflow-x: hidden; overflow-y: auto; height: calc(100vh - 8.563rem)">
  <div style="text-align: center">
    <span style="font-size: 1.688rem; color: #4c4c4c">Manage DOA Approvers</span>
  </div>
  <div
    style="
      background-color: #f3fafd;
      padding-top: 1.5rem;
      width: 68rem;
      margin-top: 1.5rem;
      display: inline-block;
    "
  >
    <div style="margin-top: 1.5rem; margin-left: 1.5rem">
      <div style="display: inline-block">
        <span class="projectScopeSubHeader" style="font-size: 0.875rem">Name, Title</span>
      </div>
      <div style="display: inline-block; margin-left: 50.438rem">
        <span class="projectScopeSubHeader" style="font-size: 0.875rem">DOA Authority Amount</span>
      </div>
    </div>
  </div>
  @for (approver of approverList; track approver; let i = $index) {
    <div style="width: 68rem; height: 6.25rem; background-color: #f3fafd; position: relative">
      <mat-form-field
        class="itFields"
        style="margin-top: 1.125rem; margin-left: 1.5rem; width: 40.763rem; height: 4rem"
      >
        <input
          [name]="autocompleteName(i)"
          type="text"
          matAutocompletePosition="below"
          matInput
          [matAutocomplete]="auto1"
          [formControl]="additionalApproverControl[i]"
          [(ngModel)]="additionalApprovers[i]"
          (keydown.enter)="searchUsersAdditionalApprover($event.target.value, i)"
          [name]="'additionalApprover' + i"
        />
      </mat-form-field>
      <mat-autocomplete
        #auto1="matAutocomplete"
        [displayWith]="displayFnAdditionalApprover"
        (optionSelected)="additionalApproverSelected($event.option.value, i)"
      >
        @for (option of additionalApproverOptions[i]; track option) {
          <mat-option style="color: #696969" [value]="option">
            @if (option.givenName && option.surname && option.jobTitle) {
              <span
                >{{ option.givenName }} {{ option.surname }} ({{ option.mail }}),
                {{ option.jobTitle }}</span
              >
            }
            @if (option.givenName && option.surname && !option.jobTitle) {
              <span>{{ option.givenName }} {{ option.surname }} ({{ option.mail }})</span>
            }
            @if (!(option.givenName && option.surname) && option.jobTitle) {
              <span>{{ option.displayName }} ({{ option.mail }}), {{ option.jobTitle }}</span>
            }
            @if (!(option.givenName && option.surname) && !option.jobTitle) {
              <span>{{ option.displayName }} ({{ option.mail }})</span>
            }
          </mat-option>
        }
      </mat-autocomplete>
      @if (additionalApprovers[i] && additionalApprovers[i].displayName) {
        <div style="display: inline-block; padding-top: 1.8rem; z-index: 0; position: absolute">
          <img
            (click)="deleteAdditionalApproverValue(i)"
            style="margin-left: -1.5rem; cursor: pointer"
            src="assets/close-window.svg"
          />
        </div>
      }
      <div
        style="display: inline-block; margin-left: 0.938rem"
        (click)="searchUsersAdditionalApprover(additionalApprovers[i], i)"
      >
        <button class="confirmButton" type="button" style="width: 5rem">
          <span class="confirmText">SEARCH</span>
        </button>
      </div>
      <div style="display: inline-block; margin-left: 5.83rem; width: 4.125rem">
        <span class="projectScopeSubHeader" style="font-size: 0.875rem; font-weight: 700"
          >${{ doaAmounts[i + 1].toLocaleString('en', { useGrouping: true }) }}</span
        >
      </div>
      <div style="display: inline-block; margin-top: 1.125rem; margin-right: 0.5rem">
        <img
          style="cursor: pointer; width: 1rem; height: 1rem; padding-left: 3.5rem"
          src="assets/trash-bin-base.svg"
          (click)="deleteApprover(i)"
        />
      </div>
    </div>
  }
  <div
    style="
      padding-left: 1rem;
      padding-top: 1.188rem;
      padding-bottom: 1.313rem;
      cursor: pointer;
      width: 15rem;
      background-color: #f3fafd;
      width: 67rem;
    "
    (click)="addNewAdditionalApprover()"
  >
    <span style="font-weight: bold; font-size: 1.4rem">&#43;</span>
    <span style="padding-left: 0.2rem; text-decoration: underline; text-underline-offset: 0.2rem"
      >Add Another Approver</span
    >
  </div>
  <div style="text-align: center">
    <div style="display: inline-block; margin-top: 2.625rem; margin-right: 0.875rem">
      <div class="exitButton" (click)="closeDialog()">
        <span class="exitText">CANCEL</span>
      </div>
    </div>
    <div style="display: inline-block; margin-top: 2.625rem">
      <button class="confirmButton" style="width: 8.125rem" (click)="saveAndClose()">
        <span class="confirmText">SAVE CHANGES</span>
      </button>
    </div>
    <div></div>
  </div>
</div>
